export default __webpack_public_path__ + "17cb3df774878b53527df877120ba426.png";